module.exports = __webpack_public_path__ + "img/prize-01.c3b0d892.png";